import { useState, useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import AIcon from "../partials/AIcon";

export default function LogsDataModal({ v }) {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        console.log(v.showChanges);
        if (v.showChanges !== null) setOpen(true)
    }, [v.showChanges])

    const handleOpen = () => {
        v.setShowChanges(null)
        setOpen(false)
        console.log("test")
        return false
    };


    return (
        <Dialog className={`min-w-[90%] md:min-w-[40%]  h-[90vh] mt-0 `}
            open={open}
            animate={{
                mount: { scale: 1, y: 0 },
                unmount: { scale: 0.9, y: -100 },
            }}
            size="md"
            static
            onClose={() => null}
        >

            <DialogHeader className="bg-main-color py-1 px-4 text-blue-gray-100  text-base flex justify-between ">
                Record Changes
                <Button className="p-0 m-0 bg-transparent" onClick={handleOpen}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
            </DialogHeader>

            <DialogBody divider className="h-[88%] overflow-scroll">
                <JSONPretty id="json-pretty" data={v.showChanges}></JSONPretty>
            </DialogBody>
            <DialogFooter className="px-4 py-1">
                <Button
                    variant="text"
                    color="red"
                    onClick={() => handleOpen()}
                    className="mr-1  mb-2 p-0"
                >
                    <span>Close</span>
                </Button>
            </DialogFooter>
        </Dialog>
    );
}